import { Table as TableIcon, LayoutGrid } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import type { TableViewMode } from "@/hooks/useTableViewMode";

interface TableViewToggleProps {
  viewMode: TableViewMode;
  onChange: (mode: TableViewMode) => void;
}

/**
 * Selector segmentado para alternar entre vista de tabla y vista de tarjetas.
 * Se ubica a la izquierda del control de visibilidad de columnas.
 */
export function TableViewToggle({ viewMode, onChange }: TableViewToggleProps) {
  return (
    <div className="inline-flex items-center -space-x-px">
      <Button
        type="button"
        variant="outline"
        size="sm"
        className={cn(
          "h-7 w-7 p-0 rounded-r-none",
          viewMode === "table"
            ? "bg-muted text-foreground hover:bg-muted hover:text-foreground"
            : "text-muted-foreground",
        )}
        aria-pressed={viewMode === "table"}
        title="Vista de tabla"
        onClick={() => onChange("table")}
      >
        <TableIcon
          className={cn(
            "h-4 w-4",
            viewMode !== "table" && "opacity-60",
          )}
        />
      </Button>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className={cn(
          "h-7 w-7 p-0 rounded-l-none",
          viewMode === "cards"
            ? "bg-muted text-foreground hover:bg-muted hover:text-foreground"
            : "text-muted-foreground",
        )}
        aria-pressed={viewMode === "cards"}
        title="Vista de tarjetas"
        onClick={() => onChange("cards")}
      >
        <LayoutGrid
          className={cn(
            "h-4 w-4",
            viewMode !== "cards" && "opacity-60",
          )}
        />
      </Button>
    </div>
  );
}

export default TableViewToggle;
